import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Badge, Container, Nav, NavItem, NavLink, Spinner } from "reactstrap";
import Swal from "sweetalert2";
import { getFirebaseAuthToken } from "../../../helpers/firebase_helper";
import PartnerMembers from "./PartnerMembers";
import PartnerUsage from "./PartnerUsage";
import PartnerCoverageReport from "./PartnerCoverageReport";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

/**
 * Admin → Partner Integrations → one partner: the members its integration
 * brought in, and everything you can do with them (see PartnerMembers).
 */
const PartnerMembersPage = () => {
  const { partnerId } = useParams();
  const [partner, setPartner] = useState(null);
  const [tab, setTab] = useState("members");

  useEffect(() => {
    (async () => {
      try {
        const res = await fetch(`${API_BASE}/dashboard/admin/partners`, {
          headers: { Authorization: `${await getFirebaseAuthToken()}` },
        });
        const json = await res.json().catch(() => ({}));
        if (!res.ok) throw new Error(json.error || "Failed to load partner");
        const found = (json.partners || []).find((p) => p.id === partnerId);
        if (!found) throw new Error("Partner not found");
        setPartner(found);
      } catch (e) {
        Swal.fire("Could not load partner", e.message, "error");
      }
    })();
  }, [partnerId]);

  return (
    <div className="page-content">
      <Container fluid>
        <div className="mb-3">
          <Link to="/admin/partner-integrations" className="small">
            ← Partner Integrations
          </Link>
          {partner ? (
            <div className="d-flex align-items-center gap-2 mt-1">
              <h3 className="mb-0">{partner.name}</h3>
              {partner.slug && (
                <Badge color="light" className="text-muted fw-normal">
                  {partner.slug}
                </Badge>
              )}
              <Badge
                color={partner.active ? "success" : "danger"}
                className="fw-normal"
              >
                {partner.active ? "Active" : "Inactive"}
              </Badge>
              <span className="text-muted small ms-2">
                {partner.groupsCount} group
                {partner.groupsCount === 1 ? "" : "s"} ·{" "}
                {partner.employeesCount} member
                {partner.employeesCount === 1 ? "" : "s"}
              </span>
            </div>
          ) : (
            <div className="mt-2">
              <Spinner size="sm" color="primary" />
            </div>
          )}
        </div>
        {partner && (
          <>
            <Nav tabs className="mb-3">
              {[
                ["members", "Members"],
                ["billing", "Billing report"],
                ["usage", "API usage"],
              ].map(([key, label]) => (
                <NavItem key={key}>
                  <NavLink
                    href="#"
                    active={tab === key}
                    onClick={(e) => {
                      e.preventDefault();
                      setTab(key);
                    }}
                  >
                    {label}
                  </NavLink>
                </NavItem>
              ))}
            </Nav>
            {tab === "members" ? (
              <PartnerMembers
                partners={[partner]}
                fixedPartnerId={partner.id}
              />
            ) : tab === "billing" ? (
              <PartnerCoverageReport partnerId={partner.id} />
            ) : (
              <PartnerUsage partnerId={partner.id} />
            )}
          </>
        )}
      </Container>
    </div>
  );
};

export default PartnerMembersPage;
